Cureus.UserMergeTool = {};

//= require_tree ./UserMergeTool
